import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { ApplicationState } from '@app/store';
import OfficeInfoBlock from '@app/components/Pages/Home/OfficeInfoBlock';

import '@app/scss/pages/contacts.scss';
import { SimpleBreadCrumbs } from '@app/components/UI/SimpleBreadcrumbs/SimpleBreadcrumbs';
import ServerPageProvider from '@app/components/UI/SeverPageProviderWithLang/ServerpageProviderWithLang';
import ShareLinks from '@app/components/UI/ShareLinks/ShareLinks';
import ContactUsForm from '@app/components/Forms/ContactUs/ContactUsForm';

const Contacts: React.FC = () => {
	const { t } = useTranslation();
	const title = t('site.Contacts');

	const offices = useSelector((state: ApplicationState) => state.offices.items, shallowEqual);

	return <div className="inner-page contacts-page container">
		<div className="clearfix">
			<SimpleBreadCrumbs title={title} />
			<ShareLinks />
		</div>
		<ServerPageProvider loader={<></>} inner={(s) => <></>} notFoundComponent={<></>} />
		<div className="inner-page__headline text-center mt10">
			<h1>{title}</h1>
		</div>
		<div className="row">
			<OfficeInfoBlock offices={offices} titleAsH2 />
		</div>
		<div className="contacts-page__form">
			<div className="inner-page__headline text-center">
				<h2>{t('site.Schedule an Appointment Now')}</h2>
			</div>
			<ContactUsForm className="general-form" />
		</div>
	</div>;
};

export default Contacts;
